var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_down_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.957 0h20v20h-20z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow_down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.175 6.913 10 10.729l3.825-3.817L15 8.087l-5 5-5-5z"
  }))));
};
export default SvgArrowDown;